import { useMutation } from "@tanstack/react-query"
import { useInjection } from "../../contexts/InversifyContext"
import CustomersApiType, { ICustomersApi, UpdateGroupCustomerRequest, CustomerBasicInfoDTO } from "../../interfaces/ICustomersApi"

export const useEditGroupCustomer = () => {
	const customerApi = useInjection<ICustomersApi>(CustomersApiType.ICustomersApi)

	return useMutation({
		mutationFn: (updateGroupCustomerRequest: UpdateGroupCustomerRequest)  => customerApi.updateGroupCustomer(updateGroupCustomerRequest),
		onError: err => {
			console.log(err)
		},
		onSuccess: () => {
			console.log("customerIds saved")
			// Optionally invalidate or refetch queries if needed
		}
	})
}
